import axios from 'axios'
import { verifyAuthenticatedUser } from 'src/util/verifyAuthenticatedUser'
import { verifyIfIsInMaintenance } from '../util/verifyIsInMaintenance'
import { autenticado, getToken } from './auth'

export const headers = {
  canal: 'gazin-ecommerce',
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Headers': '*',
}

export const apiV2 = axios.create({
  baseURL: process.env.REACT_APP_API_URI_V2,
  headers: { ...headers },
})

apiV2.interceptors.request.use(function (config) {
  if (typeof window !== 'undefined' && autenticado()) {
    config.headers.authorization = `Bearer ${getToken()}`
  }
  return config
})

apiV2.interceptors.response.use(
  (response) => response,
  (error) => verifyAuthenticatedUser(error)
)

apiV2.interceptors.response.use(
  (response) => response,
  (error) => verifyIfIsInMaintenance(error)
)
